import { render, staticRenderFns } from "./rc-info-chip.vue?vue&type=template&id=8727265a&scoped=true&"
import script from "./rc-info-chip.vue?vue&type=script&lang=js&"
export * from "./rc-info-chip.vue?vue&type=script&lang=js&"
import style0 from "./rc-info-chip.vue?vue&type=style&index=0&id=8727265a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8727265a",
  null
  
)

export default component.exports